/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetManagedAssistantSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetManagedAssistantRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetManagedAssistantSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetManagedAssistantSecurity$outboundSchema: z.ZodMiniType<
  GetManagedAssistantSecurity$Outbound,
  GetManagedAssistantSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getManagedAssistantSecurityToJSON(
  getManagedAssistantSecurity: GetManagedAssistantSecurity,
): string {
  return JSON.stringify(
    GetManagedAssistantSecurity$outboundSchema.parse(
      getManagedAssistantSecurity,
    ),
  );
}

/** @internal */
export type GetManagedAssistantRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetManagedAssistantRequest$outboundSchema: z.ZodMiniType<
  GetManagedAssistantRequest$Outbound,
  GetManagedAssistantRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getManagedAssistantRequestToJSON(
  getManagedAssistantRequest: GetManagedAssistantRequest,
): string {
  return JSON.stringify(
    GetManagedAssistantRequest$outboundSchema.parse(getManagedAssistantRequest),
  );
}
